import React, { useEffect } from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react'
import componentDisplayExtension from '../../commonUtils/ComponentDisplayExtension';

const RecipeLayout = (props) => {
    //IFRAME: Code to check displaying based on querystring
    if (!componentDisplayExtension.isDisplay(props)) {
        return (<></>)
    }
    //---------------------------------------------

    return (
        <div>
            <Placeholder name="main-layout" rendering={props.rendering} itemid={props.itemidkey} />
        </div>
    )
};

export default RecipeLayout;
